//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalBetBuilder',
  data() {
    return {
      currentLocale: null
    }
  },
  computed: {
    availableLocales() {
      return this.$i18n.locales
    },
    oddsFormat() {
      return this.$store.state.settings.oddsFormat
    },
    acceptOdds() {
      return this.$store.state.settings.acceptOdds
    }
  },
  created() {
    this.currentLocale = this.$i18n.locale
  },
  async mounted() {
    //this.listenPostMessage();
  },
  methods: {
    close() {
      this.$modal.hide('modal-betbuilder')
    },
    async listenPostMessage() {
        const childWindow = this.$refs['betbuilder'].contentWindow;
        window.addEventListener('message', async(message) => {
            if (message.source === childWindow) {
                var msg = JSON.parse(message.data);

                let params = {
                  id: _.get(msg, 'betslipUid'),
                  bookmaker: this.$config.BOOKMAKER
                }
                
                const response = await this.$api().$get('/v1/betbuilder/ticket', {params: params});
                console.log('response', response);

                this.$store.commit('betbuilder/setSelections', _.get(response, 'ticket.selections'))
                this.$store.commit('betbuilder/setTicket', _.get(response, 'ticket'))
                this.$store.commit('betbuilder/setLastUpdate')
                this.close();
                return; 
            }
        });

    }
  }
}
